import { render, staticRenderFns } from "./AssetVulnerability.vue?vue&type=template&id=378a8f03&scoped=true&"
import script from "./AssetVulnerability.vue?vue&type=script&lang=js&"
export * from "./AssetVulnerability.vue?vue&type=script&lang=js&"
import style0 from "./AssetVulnerability.vue?vue&type=style&index=0&id=378a8f03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378a8f03",
  null
  
)

export default component.exports